import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import {
  RequestContext,
  RequestState,
  IRequestContext,
} from "./RequestContext";

interface Props {
  children: React.ReactNode;
  context: IRequestContext;
  fetchingMessage?: string;
}

export const RequestWrapper: React.FC<Props> = ({
  children,
  context,
  fetchingMessage,
}) => {
  return (
    <RequestContext.Provider value={context}>
      <>
        {context.state === RequestState.Fetching &&
          fetchingMessage !== undefined && <p>{fetchingMessage}</p>}
        {context.state === RequestState.Error && context.errorMessage && (
          <Alert
            key="fetchingError"
            severity="error"
            onClose={() => context.setState(RequestState.Idle)}
            sx={{ marginBottom: 2 }}
          >
            <AlertTitle>Error</AlertTitle>
            <div>{context.errorMessage}</div>
          </Alert>
        )}
        {children}
      </>
    </RequestContext.Provider>
  );
};
